type CountryAlpha2Mapping = { [country: string]: string };

export const worldAlpha2Mapping: CountryAlpha2Mapping = {
	"Afghanistan": "AF",
	"Albanië": "AL",
	"Algerije": "DZ",
	"Andorra": "AD",
	"Angola": "AO",
	"Antigua en Barbuda": "AG",
	"Argentinië": "AR",
	"Armenië": "AM",
	"Aruba": "AW",
	"Australië": "AU",
	"Oostenrijk": "AT",
	"Azerbeidzjan": "AZ",
	"Bahama's": "BS",
	"Bahrein": "BH",
	"Bangladesh": "BD",
	"Barbados": "BB",
	"België": "BE",
	"Belize": "BZ",
	"Benin": "BJ",
	"Bhutan": "BT",
	"Bolivia": "BO",
	"Bonaire": "BQ",
	"Bosnië-Herzegovina": "BA",
	"Botswana": "BW",
	"Brazilië": "BR",
	"Brunei": "BN",
	"Bulgarije": "BG",
	"Burkina Faso": "BF",
	"Burundi": "BI",
	"Cambodja": "KH",
	"Curaçao": "CW",
	"Kameroen": "CM",
	"Canada": "CA",
	"Kaapverdië": "CV",
	"Centraal-Afrikaanse Republiek": "CF",
	"Tsjaad": "TD",
	"Chili": "CL",
	"China": "CN",
	"Colombia": "CO",
	"Comoren": "KM",
	"Congo": "CG",
	"Congo DR": "CD",
	"Congo-Brazzaville": "CG",
	"Congo-Kinshasa": "CD",
	"Costa Rica": "CR",
	"Kroatië": "HR",
	"Cuba": "CU",
	"Cyprus": "CY",
	"Tsjechië": "CZ",
	"Denemarken": "DK",
	"Djibouti": "DJ",
	"Dominica": "DM",
	"Dominicaanse Republiek": "DO",
	"Oost-Timor": "TL",
	"Ecuador": "EC",
	"Egypte": "EG",
	"El Salvador": "SV",
	"Engeland": "GB",
	"Equatoriaal-Guinea": "GQ",
	"Eritrea": "ER",
	"Estland": "EE",
	"Ethiopië": "ET",
	"Fiji": "FJ",
	"Finland": "FI",
	"Frankrijk": "FR",
	"Gabon": "GA",
	"Gambia": "GM",
	"Georgië": "GE",
	"Duitsland": "DE",
	"Ghana": "GH",
	"Griekenland": "GR",
	"Grenada": "GD",
	"Guatemala": "GT",
	"Guinee": "GN",
	"Guinee-Bissau": "GW",
	"Guyana": "GY",
	"Haïti": "HT",
	"Vaticaanstad": "VA",
	"Honduras": "HN",
	"Hongarije": "HU",
	"IJsland": "IS",
	"India": "IN",
	"Indonesië": "ID",
	"Iran": "IR",
	"Irak": "IQ",
	"Ierland": "IE",
	"Israël": "IL",
	"Italië": "IT",
	"Ivoorkust": "CI",
	"Jamaica": "JM",
	"Japan": "JP",
	"Jordanië": "JO",
	"Kazachstan": "KZ",
	"Kenia": "KE",
	"Kiribati": "KI",
	"Kosovo": "XK",
	"Noord-Korea": "KP",
	"Zuid-Korea": "KR",
	"Koeweit": "KW",
	"Kirgizië": "KG",
	"Laos": "LA",
	"Letland": "LV",
	"Libanon": "LB",
	"Lesotho": "LS",
	"Liberia": "LR",
	"Libië": "LY",
	"Liechtenstein": "LI",
	"Litouwen": "LT",
	"Luxemburg": "LU",
	"Noord-Macedonië": "MK",
	"Madagaskar": "MG",
	"Malawi": "MW",
	"Maleisië": "MY",
	"Maldiven": "MV",
	"Mali": "ML",
	"Malta": "MT",
	"Marshalleilanden": "MH",
	"Mauritanië": "MR",
	"Mauritius": "MU",
	"Mexico": "MX",
	"Micronesia": "FM",
	"Moldavië": "MD",
	"Monaco": "MC",
	"Mongolië": "MN",
	"Montenegro": "ME",
	"Marokko": "MA",
	"Mozambique": "MZ",
	"Myanmar": "MM",
	"Namibië": "NA",
	"Nauru": "NR",
	"Nepal": "NP",
	"Nederland": "NL",
	"Nieuw-Zeeland": "NZ",
	"Nicaragua": "NI",
	"Niger": "NE",
	"Nigeria": "NG",
	"Noorwegen": "NO",
	"Oman": "OM",
	"Pakistan": "PK",
	"Palau": "PW",
	"Panama": "PA",
	"Papoea-Nieuw-Guinea": "PG",
	"Paraguay": "PY",
	"Peru": "PE",
	"Filipijnen": "PH",
	"Polen": "PL",
	"Portugal": "PT",
	"Qatar": "QA",
	"Roemenië": "RO",
	"Rusland": "RU",
	"Rwanda": "RW",
	"Saba": "BQ",
	"Saint Kitts en Nevis": "KN",
	"Saint Lucia": "LC",
	"Saint Vincent en de Grenadines": "VC",
	"Samoa": "WS",
	"San Marino": "SM",
	"Sao Tomé en Principe": "ST",
	"Saoedi-Arabië": "SA",
	"Senegal": "SN",
	"Servië": "RS",
	"Seychellen": "SC",
	"Sierra Leone": "SL",
	"Singapore": "SG",
	"Sint Maarten": "SX",
	"Sint Eustatius": "BQ",
	"Slowakije": "SK",
	"Slovenië": "SI",
	"Salomonseilanden": "SB",
	"Somalië": "SO",
	"Zuid-Afrika": "ZA",
	"Zuid-Soedan": "SS",
	"Spanje": "ES",
	"Sri Lanka": "LK",
	"Soedan": "SD",
	"Suriname": "SR",
	"Zweden": "SE",
	"Zwitserland": "CH",
	"Syrië": "SY",
	"Tadzjikistan": "TJ",
	"Tanzania": "TZ",
	"Thailand": "TH",
	"Togo": "TG",
	"Tonga": "TO",
	"Trinidad en Tobago": "TT",
	"Tunesië": "TN",
	"Turkije": "TR",
	"Turkmenistan": "TM",
	"Tuvalu": "TV",
	"Oeganda": "UG",
	"Oekraïne": "UA",
	"Verenigde Arabische Emiraten": "AE",
	"Verenigd Koninkrijk": "GB",
	"Verenigde Staten": "US",
	"Uruguay": "UY",
	"Oezbekistan": "UZ",
	"Vanuatu": "VU",
	"Venezuela": "VE",
	"Vietnam": "VN",
	"Jemen": "YE",
	"Zambia": "ZM",
	"Zimbabwe": "ZW",
};
